import type { TherapistProfile } from '../../../../types/therapist-dashboard.types';

// Editable fields from profile
export interface EditableProfileData {
  firstName: string;
  lastName: string;
  phone: string;
  bio: string;
  specialty: string[];
  settings: {
    autoAcceptBookings: boolean;
    bufferTimeBetweenAppointments: number;
    maxDailyAppointments: number;
    emailNotifications: boolean;
    smsNotifications: boolean;
  };
}

// Default settings
export const DEFAULT_SETTINGS: EditableProfileData['settings'] = {
  autoAcceptBookings: false,
  bufferTimeBetweenAppointments: 15,
  maxDailyAppointments: 8,
  emailNotifications: true,
  smsNotifications: false,
};

// Extract editable data from profile
export function extractEditableData(profile: TherapistProfile): EditableProfileData {
  return {
    firstName: profile.firstName,
    lastName: profile.lastName,
    phone: profile.phone || '',
    bio: profile.bio || '',
    specialty: [...profile.specialty],
    settings: profile.settings ? { ...profile.settings } : { ...DEFAULT_SETTINGS },
  };
}

// Check if data has changed
export function hasDataChanged(
  original: EditableProfileData,
  current: EditableProfileData
): boolean {
  if (original.firstName !== current.firstName) return true;
  if (original.lastName !== current.lastName) return true;
  if (original.phone !== current.phone) return true;
  if (original.bio !== current.bio) return true;
  if (original.specialty.length !== current.specialty.length) return true;
  if (original.specialty.some((s, i) => current.specialty[i] !== s)) return true;
  if (original.settings.autoAcceptBookings !== current.settings.autoAcceptBookings)
    return true;
  if (
    original.settings.bufferTimeBetweenAppointments !==
    current.settings.bufferTimeBetweenAppointments
  )
    return true;
  if (original.settings.maxDailyAppointments !== current.settings.maxDailyAppointments)
    return true;
  if (original.settings.emailNotifications !== current.settings.emailNotifications)
    return true;
  if (original.settings.smsNotifications !== current.settings.smsNotifications) return true;
  return false;
}
